// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/home/jenkins/agent/workspace/p1921wq4gm/p1921-arena-admin-frontend-prod/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: "@@initialState", model: model_1 },
} as const
